import { WinningCriteriaSettings } from './WinningCriteriaSettings';

export const STOSettings = () => {
  return <WinningCriteriaSettings />;
};
